import React, { useState, useEffect, useRef } from 'react';
import { PropagateLoader } from 'react-spinners';
import '../../src/App.css';

import racebaseLogo from '../assets/images/general/racebaseLogo_symbol_white.png';
import racebaseText from '../assets/images/general/racebaseText_whiteText.png';

const EmailConfirmation = () => {
  const [loading, setLoading] = useState(true);
  const [confirmationState, setConfirmationState] = useState({ status: null, message: null });
  const hasLoadedBefore = useRef(false);

  function displayResult(status, message) {
    setConfirmationState({ status, message });
    setTimeout(() => setLoading(false), 1500);
  }

  useEffect(() => {
    if (hasLoadedBefore.current) return;
    hasLoadedBefore.current = true;

    const params = new URLSearchParams(window.location.search);
    const type = params.get('type');
    const accessToken = params.get('access_token');

    const successMessages = {
      signup: 'Your email has been verified. You can now open the Racebase app and sign in.',
      email_change: 'Your email was successfully updated.',
      invite: 'You’ve successfully joined. You can now log in using your verified email.',
    };

    if (!accessToken) {
      // No token, show error immediately
      setLoading(false);
      displayResult('fail', 'Invalid or expired confirmation link.');
      return;
    }

    if (successMessages[type]) {
      displayResult('success', successMessages[type]);
    } else {
      displayResult('fail', 'Invalid or expired confirmation link.');
    }
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src={racebaseLogo} className="App-logo" alt="RACEBASE_LOGO" />
        <div className="message-container">
          {loading ? (
            <div className="spinner">
              <PropagateLoader color="white" loading={loading} size={10} />
            </div>
          ) : (
            <div
              className={
                confirmationState.status === 'success'
                  ? 'success-message'
                  : 'error-message'
              }
            >
              <p>{confirmationState.message}</p>
            </div>
          )}
        </div>
      </header>
      <div className="bottom-corner">
        <img src={racebaseText} alt="RACEBASE" className="bottom-corner-img" />
        <p className="bottom-corner-text">{new Date().getFullYear()}</p>
      </div>
    </div>
  );
};

export default EmailConfirmation;